export default function name(){
    return(
        <div className="col">    
            <div className="card-body text-center">
                <h3 className="card-title text-original-dark-blue"><i className="fa fa-info-circle fa-2x" aria-hidden="true"></i></h3>
                <h4 className="card-subtitle mb-2 text-muted">Sobre</h4>
                <p className="card-text text-justify">
                    O grupo de pesquisa IF4Health foi fundado em 2020 e é composto atualmente por 3 professores doutores do campus Charqueadas, nas áreas de Engenharia Elétrica e Ciência da Computação. O objetivo do grupo é realizar pesquisas aplicadas na área biomédica, focando a conectivdade dos sistemas, de forma interdisciplinar.
                </p>
            </div>
        </div>    
    );
}